import { PotentialAnswerType, SelectedAnswerType } from '@data/types';

export const disableButton = (
  potentialAnswers: PotentialAnswerType[],
  selectedAnswers: SelectedAnswerType[]
) => {
  // Does the question have multiple options?
  if (
    Array.isArray(potentialAnswers) &&
    potentialAnswers[0]?.type !== 'button'
  ) {
    // Loop through all of the potential answers, if any undefined disable the button
    const allAnswered =
      selectedAnswers.length === potentialAnswers.length &&
      selectedAnswers.every(
        (answer) => answer.answer !== undefined && answer.answer !== ''
      );
    return !allAnswered;
  }

  // Is the question text?
  return selectedAnswers.length === 0;
};

export const nextButtonText = (isLastQuestion: boolean): string => {
  return isLastQuestion ? 'Submit' : 'Next question';
};

// Define the types for the stores and selected answers
type SetDisplayResultsStoreFunction = (value: boolean) => void;
type SetQuestionIndexStoreFunction = (index: number) => void;
type SetAnswerStoreFunction = (
  pillarId: number,
  questionId: number,
  answers: SelectedAnswerType[]
) => void;

/* eslint-disable */
// Disabled due to large number of params
export const nextButtonOnclick = (
  isLastQuestion: boolean,
  setDisplayResultsStore: SetDisplayResultsStoreFunction,
  setQuestionIndexStore: SetQuestionIndexStoreFunction,
  setAnswerStore: SetAnswerStoreFunction,
  index: number,
  pillarIndex: number,
  questionIndexStore: number,
  selectedAnswers: SelectedAnswerType[],
  displayResultsStore: boolean
): void => {
  if (isLastQuestion) {
    setDisplayResultsStore(!displayResultsStore);
  } else {
    // Increment Question
    setQuestionIndexStore(index + 1);
  }

  // Push user to top
  window.scrollTo(0, 0);

  // Save answer
  setAnswerStore(pillarIndex, questionIndexStore, selectedAnswers);
};
/* eslint-enable */
